import { createAction } from "@reduxjs/toolkit";

import {
  blockAuthorActionType,
  setAuthorsActionType,
  unblockAuthorActionType,
  blockedByUserActionTypes,
  unblockedByUserActionTypes,
  setAuthorDeletedActionType,
} from "./actionTypes";

export const setAuthors = createAction(setAuthorsActionType);
export const blockAuthor = createAction(blockAuthorActionType);
export const unblockAuthor = createAction(unblockAuthorActionType);
export const makeAuthorDeleted = createAction(setAuthorDeletedActionType);

export const blockedByUserSuccess = createAction(
  blockedByUserActionTypes.success,
);

export const unblockedByUserSuccess = createAction(
  unblockedByUserActionTypes.success,
);
